import { createRoutes } from "common/routes/routes.utils";

import { AddressBookViews } from "@bps/blocks";

import { Permission } from "../../core/common-types/permission.enum";

export const routes = {
  appointmentBooking: createRoutes({
    basePath: { path: "/booking/*", text: "Booking" },
    locationEdit: {
      path: "/booking/practice-profile",
      text: "Online configuration"
    },
    onlineSettings: {
      path: "/booking/online-settings",
      text: "Online settings"
    }
  }),
  bpMobile: {
    text: "Mobile",
    path: "/mobile",
    permissions: Permission.ProsBpmWebAllowed
  },

  bpMobileBooking: createRoutes({
    appointments: {
      text: "Appointments",
      path: "/mobile/appointments",
      permissions: Permission.ProsBpmWebAllowed
    },
    bookingCalendar: {
      text: "Booking calendar",
      path: "/mobile/booking-calendar",
      permissions: Permission.ProsBpmWebAllowed
    }
  }),
  bpMobileClinicalRecord: createRoutes({
    basePath: {
      text: "Clinical record",
      path: "/mobile/clinical-record",
      permissions: Permission.ProsBpmWebAllowed
    },
    view: {
      text: "Clinical record",
      path: "/mobile/clinical-record/:id",
      permissions: Permission.ProsBpmWebAllowed
    },
    edit: {
      text: "Clinical record",
      path: "/mobile/clinical-record/patient/:patientId/:encounterId/:appointmentId?",
      permissions: [Permission.ProsBpmWebAllowed, Permission.BpmConsultAllowed],
      permissionsOperator: "and"
    }
  }),
  bpMobileAddressBook: createRoutes({
    basePath: {
      text: "Address book",
      path: "/mobile/address-book/:view?",
      permissions: Permission.ProsBpmWebAllowed
    },
    patients: {
      text: "Patients",
      path: `/mobile/address-book/${AddressBookViews.Patients}`,
      permissions: Permission.ProsBpmWebAllowed
    }
  }),
  bpMobileTodo: createRoutes({
    userInbox: {
      text: "Inbox",
      path: "/mobile/to-do/inbox",
      permissions: Permission.ProsBpmWebAllowed
    }
  }),
  bpMobileDocumentEditor: createRoutes({
    basePath: {
      text: "document editor",
      path: "/mobile/document-editor",
      permissions: Permission.ProsBpmWebAllowed
    },
    edit: {
      text: "document editor",
      path: "/mobile/document-editor/:id",
      permissions: Permission.ProsBpmWebAllowed
    }
  }),
  bpMobileDashboard: createRoutes({
    basePath: {
      text: "Dashboard",
      path: "/mobile",
      permissions: Permission.ProsBpmWebAllowed
    }
  }),
  dashboard: createRoutes({
    basePath: {
      text: "Dashboard",
      path: "/"
    }
  }),
  settings: createRoutes({
    basePath: {
      text: "Settings",
      path: "/settings/*",
      customPermissionsCheck: userPermissions => {
        return (
          userPermissions.includes(Permission.ProsOnlineSettingsAllowed) &&
          userPermissions.some(p =>
            [
              Permission.PerPltLicenceRead,
              Permission.PerPltLicenceWrite,
              Permission.PerPltUserRead,
              Permission.PerPltUserWrite,
              Permission.PerPltNetworkRead,
              Permission.PerPltNetworkWrite,
              Permission.BHB_WRITE,
              Permission.BHB_READ
            ].includes(p)
          )
        );
      }
    },
    home: {
      text: "Home",
      path: "/settings/home"
    },
    networkAndSecurity: {
      text: "Network and security",
      path: "/settings/network-and-security"
    },
    mobileLicences: {
      text: "Mobile",
      path: "/settings/:productFamilyCode/licences"
    },
    bestHealthBooking: {
      text: "Best Health Booking",
      path: "/settings/bhb/*"
    }
  })
};
